module.exports = __webpack_public_path__ + "static/media/CytaVision_Cipro.6f529a2c.png";